import { combineReducers } from 'redux';
import productsReducer from './slices/ProducsSlice';
import ticketsReducer from './slices/TicketsSlice';
import breadcrumbsSlice from './slices/BreadcrumbsSlice';
import giftCardReducer from './slices/GiftCardSlice';
import issuesSlice from './slices/IssuesSlice';
import rutsReducer from './slices/RutsSlice';
import validationProductSlice from './slices/ValidationProductSlice';
import reCaptchaSlice from './slices/reCaptchaSlice';
import validationDniSlice from './slices/ValidationDniSlice';
import routesAuthSlice from './slices/RoutesAuthSlice';

const MainReducer = combineReducers({
  productsReducer,
  ticketsReducer,
  breadcrumbsSlice,
  giftCardReducer,
  issuesSlice,
  rutsReducer,
  validationProductSlice,
  reCaptchaSlice,
  validationDniSlice,
  routesAuthSlice,
});

export default MainReducer;
